import EnemyType from "../../enums/EnemyType";
import EnemyData from "./EnemyDataInterface";

const GREEN_STAGES_ENEMIES: {
  [key in EnemyType]?: EnemyData[];
} = {
  //replaces SMALL_HAMSTER1 and SMALL_HAMSTER2
  [EnemyType.CHICKEN]: [
    {
      level: 1,
      maxHp: 0.1,
      speed: 130,
      power: 1.5,
      knockback: 1,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 1.5,
      spriteName: "chicken",
      animationKey: "chicken_run",
    },
  ],
  //replaces FAT_HAMSTER
  [EnemyType.DUCK]: [
    {
      level: 1,
      maxHp: 1,
      speed: 150,
      power: 4,
      knockback: 1,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 1.5,
      spriteName: "duck",
      animationKey: "duck_run",
    },
  ],
  //replaces SCORPION
  [EnemyType.SPIDER]: [
    {
      level: 1,
      maxHp: 1,
      speed: 240,
      power: 10,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      xp: 1.5,
      spriteName: "spider",
      animationKey: "spider_run",
    },
  ],
  //replaces SNAKE1
  [EnemyType.MOUSEMAN]: [
    {
      level: 1,
      maxHp: 6,
      speed: 100,
      power: 12,
      knockback: 0.8,
      deathKB: 4,
      killedAmount: 0,
      scale: 1.4,
      xp: 2,
      spriteName: "mouseman",
      animationKey: "mouseman_run",
    },
  ],
  //replaces SNAKE2
  [EnemyType.MOUSEMAN2]: [
    {
      level: 1,
      maxHp: 14,
      speed: 110,
      power: 15,
      knockback: 0.8,
      deathKB: 4,
      killedAmount: 0,
      scale: 1.4,
      xp: 2.5,
      spriteName: "mouseman2",
      animationKey: "mouseman2_run",
    },
  ],
  //replaces CACTUS
  [EnemyType.TREANT]: [
    {
      level: 1,
      maxHp: 16,
      speed: 100,
      power: 10,
      knockback: 1,
      deathKB: 5,
      killedAmount: 0,
      scale: 1.7,
      xp: 2,
      spriteName: "treant",
      animationKey: "treant_run",
    },
  ],
  //replaces WARRIOR_HAMSTER
  [EnemyType.SKELETON]: [
    {
      level: 1,
      maxHp: 25,
      speed: 140,
      power: 25,
      knockback: 1,
      deathKB: 1,
      killedAmount: 0,
      scale: 1.2,
      xp: 2.5,
      spriteName: "skeleton",
      animationKey: "skeleton_run",
    },
  ],
  //replaces VULTURE
  [EnemyType.BEE]: [
    {
      level: 1,
      maxHp: 24,
      speed: 180,
      power: 25,
      knockback: 0.8,
      deathKB: 7,
      killedAmount: 0,
      scale: 1,
      xp: 1.5,
      spriteName: "bee",
      animationKey: "bee_run",
    },
  ],
  //replaces GOLEM
  [EnemyType.GREEN_GOLEM]: [
    {
      level: 10,
      maxHp: 30,
      speed: 130,
      power: 45,
      knockback: 0.1,
      deathKB: 2,
      killedAmount: 0,
      xp: 2.5,
      spriteName: "green_golem",
      animationKey: "green_golem_run",
    },
  ],
  // replaces REPTILE
  [EnemyType.WOLF]: [
    {
      level: 10,
      maxHp: 70,
      speed: 160,
      power: 55,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      scale: 0.8,
      xp: 3,
      spriteName: "wolf",
      animationKey: "wolf_run",
    },
  ],
};
export default GREEN_STAGES_ENEMIES;
  
  